<div class="wizard-filter-section-component">
  <ng-container *ngFor="let key of groupKeys">
    <ng-container *ngIf="key === this.firstGroupKeyWithTitle">
      <div class="titles-row" nz-row>
        <nz-form-item nz-col [ngStyle]="{'min-width': columnWidthPercent != '' ? columnWidthPercent : 'inherit'}"
          nzXs="24" nzSm="24" [nzMd]="embdedSection ? 24 : 12" [nzLg]="embdedSection ? 24 : 6"
          [nzXl]="embdedSection ? 24 : 4">
        </nz-form-item>
        <nz-form-item nz-col [ngStyle]="{
        'min-width': columnWidthPercent != '' ? columnWidthPercent : 'inherit'
      }" nzXs="24" nzSm="24" [nzMd]="embdedSection ? 24 : 12" [nzLg]="embdedSection ? 24 : 6"
          [nzXl]="embdedSection ? 24 : 4">
          <b>{{'From' | locale}}</b>
        </nz-form-item>
        <nz-form-item nz-col [ngStyle]="{
        'min-width': columnWidthPercent != '' ? columnWidthPercent : 'inherit'
      }" nzXs="24" nzSm="24" [nzMd]="embdedSection ? 24 : 12" [nzLg]="embdedSection ? 24 : 6"
          [nzXl]="embdedSection ? 24 : 4">
          <b>{{'To' | locale}}</b>
        </nz-form-item>
      </div>
    </ng-container>
    <div nz-row>
      <nz-form-item *ngIf="groupKeysTitles[key] != null" nz-col [ngStyle]="{
        'min-width': columnWidthPercent != '' ? columnWidthPercent : 'inherit'
      }" nzXs="24" nzSm="24" [nzMd]="embdedSection ? 24 : 12" [nzLg]="embdedSection ? 24 : 6"
        [nzXl]="embdedSection ? 24 : 4">
        {{groupKeysTitles[key]}}
      </nz-form-item>
      <nz-form-item nz-col [ngStyle]="{
        'min-width': columnWidthPercent != '' ? columnWidthPercent : 'inherit'
      }" nzXs="24" nzSm="24" [nzMd]="embdedSection ? 24 : 12" [nzLg]="embdedSection ? 24 : 6"
        [nzXl]="embdedSection ? 24 : 4" *ngFor="let field of groupedFilterFields[key]">
        <ng-container *ngIf="
          field.AdditionalInformationParsed.Visible ||
          (fieldsToShow.size > 0 && fieldsToShow.has(field.PropertyName))
        ">
          <nz-form-label [nzFor]="field.FieldName" *ngIf="groupKeysTitles[key] == null && field.DataType !== 18"
            [nzRequired]="field?.Required">{{
            field.Label | locale
            }}</nz-form-label>
          <nz-form-control>
            <ng-container *ngIf="field.DataType == 1">
              <nz-input-group [nzSuffix]="inputClearTpl">
                <input type="text" nz-input [ngModelOptions]="{ updateOn: 'blur' }" [(ngModel)]="field.Value"
                  (ngModelChange)="fieldsChanged(field.FieldName)" />
              </nz-input-group>
              <ng-template #inputClearTpl><i nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                  *ngIf="field.Value" (click)="field.Value = null"></i>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="field.DataType == 7">
              <textarea nz-input [ngModelOptions]="{ updateOn: 'blur' }" [(ngModel)]="field.Value"
                (ngModelChange)="fieldsChanged(field.FieldName)"></textarea>
            </ng-container>
            <ng-container *ngIf="field.DataType == 9">
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1" [ngModelOptions]="{ updateOn: 'blur' }"
                [(ngModel)]="field.Value" [nzFormatter]="formatterPercent" [nzParser]="parserPercent"
                (ngModelChange)="fieldsChanged(field.FieldName)"></nz-input-number>
            </ng-container>
            <ng-container *ngIf="field.DataType == 26">
              <nz-input-number [nzStep]="1" [ngModelOptions]="{ updateOn: 'blur' }" [(ngModel)]="field.Value"
                [nzFormatter]="formatterQuantity" [nzParser]="numberParser"
                (ngModelChange)="fieldsChanged(field.FieldName)"></nz-input-number>
            </ng-container>
            <ng-container *ngIf="field.DataType == 3">
              <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'Select a ' + field.Label | locale"
                [(ngModel)]="field.Value" (ngModelChange)="fieldsChanged(field.FieldName)" [nzMode]="
                field.AdditionalInformationParsed.IsMultiple
                  ? 'multiple'
                  : 'default'
              ">
                <ng-container *ngFor="let option of field.Options">
                  <nz-option [nzValue]="option.Code.toString()" [nzLabel]="option.Name"></nz-option>
                </ng-container>
              </nz-select>
            </ng-container>
            <ng-container *ngIf="field.DataType == 4">
              <nz-input-group nzSearch [nzSuffix]="inputClearTpl" [nzAddOnAfter]="suffixIconButton">
                <input nz-input [(ngModel)]="field.Value" (input)="onType($event, field)"
                  [ngModelOptions]="{ updateOn: 'blur' }" (ngModelChange)="validateSelection(field, field.Value)"
                  [nzAutocomplete]="auto" />
              </nz-input-group>
              <ng-template #suffixIconButton>
                <button nz-button nzType="default" nzSearch (click)="openSearchDrawer(field)">
                  <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
                </button>
              </ng-template>
              <ng-template #inputClearTpl><i nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                  *ngIf="field.Value !== '' && field.Value !== undefined && field.Value !== null" (click)="removeSelection(field)"></i>
              </ng-template>
              <nz-autocomplete #auto [nzOverlayClassName]="'linked-field-overlay'">
                <nz-auto-option *ngFor="let option of options" [nzValue]="option.value">{{ option.label }}
                </nz-auto-option>
              </nz-autocomplete>
            </ng-container>
            <ng-container *ngIf="field.DataType == 5">
              <app-filter-fields-date (filterFieldsChange)="fieldsChanged(field.FieldName)" [field]="field"
                [filterFields]="filterFields" [customerCode]="customerCode">

              </app-filter-fields-date>
            </ng-container>
            <ng-container *ngIf="field.DataType == 33">
              <nz-input-number [nzFormatter]="formatterNumber" nzMin="0" [name]="field.FieldName"
                [(ngModel)]="field.Value" (ngModelChange)="fieldsChanged(field.FieldName)">
              </nz-input-number>
            </ng-container>
            <ng-container *ngIf="field.DataType == 12">
              {{field.Value}}
            </ng-container>
            <ng-container *ngIf="field.DataType == 18">
              <label nz-checkbox [(ngModel)]="field.Value"
                (ngModelChange)="fieldsChanged(field.FieldName)">{{field.Label
                | locale}}</label>
            </ng-container>
            <ng-container *ngIf="field.DataType == 10">
              <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                <input nz-input [(ngModel)]="field.Value" #attachmentInput readonly hidden />
                <input nz-input [value]="attachmentInput.value | attachmentSlice" type="text" [name]="field.FieldName"
                  readonly />
                <nz-drawer #mediaDrawer nzPlacement="bottom" [nzTitle]="'Choose Media' | locale" nzHeight="650px"
                  [nzVisible]="field.isAttachmentDrawerVisible" (nzOnClose)="field.isAttachmentDrawerVisible = false">
                  <app-media-container [isImage]="field.AdditionalInformationParsed.IsImage"
                    [allowUploadFile]="field.AdditionalInformationParsed.AllowUploadFile"
                    [allowSignature]="field.AdditionalInformationParsed.AllowSignature"
                    [allowUsingCamera]="field.AdditionalInformationParsed.AllowUsingCamera"
                    *ngIf="field.isAttachmentDrawerVisible"
                    (fileUploaded)="field.Value = $event; fieldsChanged(field.FieldName); field.isAttachmentDrawerVisible = false;">
                  </app-media-container>
                </nz-drawer>
              </nz-input-group>
              <ng-template #suffixIconButton>
                <nz-button-group>
                  <button *ngIf="field.Value != null" nz-button nzType="default" nzSearch
                    (click)="field.Value = ''; fieldsChanged(field.FieldName);">
                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                  </button>
                  <button nz-button nzType="default" nzSearch (click)="preview(field.Value);">
                    <i nz-icon nzType="eye" nzTheme="outline"></i>
                  </button>
                  <button nz-button nzType="default" nzSearch (click)="field.isAttachmentDrawerVisible = true;">
                    <i nz-icon nzType="upload" nzTheme="outline"></i>
                  </button>
                </nz-button-group>
              </ng-template>
            </ng-container>
          </nz-form-control>
        </ng-container>
      </nz-form-item>
    </div>
  </ng-container>
  <div nz-row *ngIf="groupKeys === undefined">
    <nz-form-item nz-col nzXs="24" nzSm="24" [nzMd]="embdedSection ? 24 : 12" [nzLg]="embdedSection ? 24 : 6"
      [nzXl]="embdedSection ? 24 : 4" *ngFor="let field of filterFields">
      <ng-container *ngIf="
          field.AdditionalInformationParsed.Visible ||
          (fieldsToShow.size > 0 && fieldsToShow.has(field.PropertyName))
        ">
        <nz-form-label [nzFor]="field.FieldName">{{
          field.Label | locale
          }}</nz-form-label>
        <nz-form-control>
          <ng-container *ngIf="field.DataType == 1">
            <nz-input-group [nzSuffix]="inputClearTpl">
              <input type="text" nz-input [ngModelOptions]="{ updateOn: 'blur' }" [(ngModel)]="field.Value" />
            </nz-input-group>
            <ng-template #inputClearTpl><i nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                *ngIf="field.Value" (click)="field.Value = null"></i>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="field.DataType == 7">
            <textarea nz-input [ngModelOptions]="{ updateOn: 'blur' }" [(ngModel)]="field.Value"></textarea>
          </ng-container>
          <ng-container *ngIf="field.DataType == 3">
            <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'Select a ' + field.Label | locale"
              [(ngModel)]="field.Value">
              <ng-container *ngFor="let option of field.Options">
                <nz-option [nzValue]="option.Code.toString()" [nzLabel]="option.Name"></nz-option>
              </ng-container>
            </nz-select>
          </ng-container>
          <ng-container *ngIf="field.DataType == 4">
            <nz-input-group nzSearch [nzSuffix]="inputClearTpl" [nzAddOnAfter]="suffixIconButton">
              <input nz-input [(ngModel)]="field.Value" (input)="onType($event, field)"
                [ngModelOptions]="{ updateOn: 'blur' }" (ngModelChange)="validateSelection(field, field.Value)"
                [nzAutocomplete]="auto" />
            </nz-input-group>
            <ng-template #suffixIconButton>
              <button nz-button nzType="default" nzSearch (click)="openSearchDrawer(field)">
                <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
              </button>
            </ng-template>
            <ng-template #inputClearTpl><i nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                *ngIf="field.Value !== '' && field.Value !== undefined" (click)="removeSelection(field)"></i>
            </ng-template>
            <nz-autocomplete #auto [nzOverlayClassName]="'linked-field-overlay'">
              <nz-auto-option *ngFor="let option of options" [nzValue]="option.value">{{ option.label }}
              </nz-auto-option>
            </nz-autocomplete>
          </ng-container>
          <ng-container *ngIf="field.DataType == 5">
            <nz-date-picker [nzFormat]="global.companyConfiguration.DateFormat" [(ngModel)]="field.Value"
              [nzDateRender]="tplRender">
            </nz-date-picker>
            <ng-template #tplRender let-current>
              <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
                {{ current.getDate() }}
              </div>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="field.DataType == 33">
            <nz-input-number [nzFormatter]="formatterNumber" nzMin="0" [name]="field.FieldName"
              [(ngModel)]="field.Value">
            </nz-input-number>
          </ng-container>
          <ng-container *ngIf="field.DataType == 12">
            {{field.Value}}
          </ng-container>
          <ng-container *ngIf="field.DataType == 18">
            <label nz-checkbox [(ngModel)]="field.Value" (ngModelChange)="fieldsChanged(field.FieldName)">{{field.Label
              | locale}}</label>
          </ng-container>
        </nz-form-control>
      </ng-container>
    </nz-form-item>
  </div>
  <ng-template [ngTemplateOutlet]="this.filterFooter"></ng-template>
  <div class="filter-button-container" *ngIf="filterFooterVisible">
    <nz-space *ngIf="!embdedSection">
      <nz-space-item>
        <button nz-button nzType="primary" (click)="emitFilterButton()" [nzLoading]="filterButtonIsLoading">
          <i nz-icon nzType="filter" nzTheme="outline"></i>
          {{ "Filter" | locale }}
        </button>
      </nz-space-item>
    </nz-space>
    <nz-space *ngIf="embdedSection" class="footer">
      <nz-space-item>
        <button nz-button nzType="primary" (click)="emitOkButton()" [nzLoading]="filterButtonIsLoading">
          {{ okButtonLabel | locale }}
        </button>
      </nz-space-item>
      <nz-space-item *ngIf="showCancelButton">
        <button nz-button (click)="emitCancelButton()">
          {{ "Cancel" | locale }}
        </button>
      </nz-space-item>
    </nz-space>
  </div>
</div>
